import { CartLinesUpdateEvent } from '@shopify/events';
import { sectionRenderer } from '@theme/section-renderer';

document.querySelectorAll('[data-ja-cart-count]').forEach(counter => {
  const updateLabel = () => counter.closest('a')?.setAttribute('aria-label', counter.closest('a').textContent.trim().replace(/\s+/g, ' '));
  new MutationObserver(updateLabel).observe(counter, { childList: true, characterData: true, subtree: true });
  updateLabel();
});

document.addEventListener('janicca:cart-added', async event => {
  if (!document.getElementById('cart-drawer')) return;
  const data = event.detail || {};
  try {
    await Promise.all([customElements.whenDefined('cart-items-component'), customElements.whenDefined('cart-drawer-component'), customElements.whenDefined('theme-drawer')]);
    const cart = data.cart || await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { credentials: 'same-origin' }).then(response => { if (!response.ok) throw new Error('Cart refresh failed'); return response.json(); });
    const lines = (data.items || []).map(item => ({ merchandiseId: String(item.id || item.variant_id), quantity: item.quantity || 1 }));
    document.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines,
      promise: Promise.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { items: cart.items, sections: data.sections, itemCount: lines.reduce((sum, item) => sum + item.quantity, 0), source: 'janicca-look', didError: false }
      })
    }));
  } catch {
    try {
      await sectionRenderer.renderSection('cart-drawer-section', { cache: false, mode: 'hydration', injectStylesheet: true });
      document.getElementById('cart-drawer')?.open();
    } catch {}
  }
});

document.addEventListener('click', async event => {
  const trigger = event.target instanceof Element ? event.target.closest('[data-jn-cart-open]') : null;
  const drawer = document.getElementById('cart-drawer');
  if (!trigger || !drawer || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
  event.preventDefault();
  await customElements.whenDefined('theme-drawer');
  drawer.open();
  try {
    await sectionRenderer.renderSection('cart-drawer-section', { cache: false, mode: 'hydration', injectStylesheet: true });
  } catch {
    window.location.assign(trigger.href);
  }
});

